import jsPDF from "jspdf";
import LogoWhite from "../../../assets/images/LogoWhite.png";

//--------------------------------------------------
// Utility: Draw Section Header with divider
//--------------------------------------------------
const drawSectionHeader = (doc, title, y) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(title, 35, y);
  
    y += 8; // spacing before line
    doc.setDrawColor(180);
    doc.setLineWidth(0.6);
    doc.line(35, y, 560, y);
  
    return y + 16; // spacing AFTER header
  };
  

//--------------------------------------------------
// Recursive content renderer
//--------------------------------------------------
const renderContent = (doc, data, y, indent = 0) => {
    const lineHeight = 14; // slightly larger for readability
    const maxWidth = 500;
    const x = 35 + indent * 18; // better indentation spacing
  
    Object.entries(data).forEach(([key, value]) => {
      if (y > 760) {
        doc.addPage();
        y = 40;
      }
  
      // ---------------- ARRAY ----------------
      if (Array.isArray(value)) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`${key}:`, x, y);
        y += lineHeight;
  
        doc.setFont("helvetica", "normal");
  
        if (value.length === 0) {
          doc.text("—", x + 12, y);
          y += lineHeight;
        } else {
          value.forEach((item) => {
            const text = typeof item === "string" ? item : JSON.stringify(item);
            const wrapped = doc.splitTextToSize(`• ${text}`, maxWidth);
            doc.text(wrapped, x + 12, y);
            y += wrapped.length * lineHeight;
          });
        }
  
        y += 6; // space after array
      }
  
      // ---------------- OBJECT ----------------
      else if (typeof value === "object" && value !== null) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`${key}:`, x, y);
        y += lineHeight;
  
        doc.setFont("helvetica", "normal");
        y = renderContent(doc, value, y, indent + 1);
  
        y += 10; // space between nested subsections
      }
  
      // ---------------- SIMPLE VALUE ----------------
      else {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`${key}:`, x, y);
  
        doc.setFont("helvetica", "normal");
        const wrapped = doc.splitTextToSize(String(value || "—"), maxWidth);
  
        doc.text(wrapped, x + 80, y); // aligned value
        y += wrapped.length * lineHeight;
  
        y += 8; // spacing after each key/value block
      }
    });
  
    return y;
  };
  
  

//--------------------------------------------------
// MAIN FUNCTION
//--------------------------------------------------
export const generateAssessmentPdf = (docData, providerName = null, isGeneratedByStudent = false) => {
  const summary = docData.summary || {};
  const assessmentName = (docData.typeOfAssessment || "Assessment Summary").trim();
  const studentName = docData?.info?.userName || "N/A";

  const date = docData?.selectedDate?._seconds
    ? new Date(docData.selectedDate._seconds * 1000).toLocaleDateString("en-US")
    : new Date().toLocaleDateString("en-US");

  const provider = providerName || docData?.info?.userName || "N/A";

  const doc = new jsPDF({
    unit: "pt",
    format: "a4",
  });

  let y = 40;

  //--------------------------------------------------
  // HEADER
  //--------------------------------------------------
  const logoX = 35, logoY = 20, logoSize = 30;

  doc.setFillColor(146, 145, 239);
  doc.circle(logoX + 15, logoY + 15, 15, "F");
  doc.addImage(LogoWhite, "PNG", logoX + 6, logoY + 6, 18, 18);

  // "mindly"
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(146, 145, 239);
  doc.text("mindly", logoX + logoSize + 12, logoY + 20);

  // Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(0, 0, 0);
  doc.text(assessmentName, 300, logoY + 20, { align: "center" });

  y = 80;

  //--------------------------------------------------
  // STUDENT + PROVIDER INFO
  //--------------------------------------------------
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);

  if (!isGeneratedByStudent)
    doc.text(`Student: ${studentName}`, 35, y);

  doc.text(`Date: ${date}`, 560, y, { align: "right" });
  y += 16;

  doc.text(
    isGeneratedByStudent
      ? `Generated By Student: ${provider}`
      : `Provider: ${provider}`,
    35,
    y
  );
  y += 20;

  y = drawSectionHeader(doc, "Assessment Summary", y);

  //--------------------------------------------------
  // SUMMARY SECTIONS
  //--------------------------------------------------
  Object.entries(summary).forEach(([sectionTitle, sectionContent]) => {
    y = drawSectionHeader(doc, sectionTitle, y);
    y = renderContent(doc, sectionContent, y, 0);
    y += 10;
  });

  return doc.output("datauristring");
};
